import { walletTermsQueryOptions } from '@src/queryOptions/terms'

import { RouterContext } from '../__root'

export const ensureUserTermsQueryData = (context: RouterContext) => {
  const storeState = context.store.getState().onboarding
  const { essentialFlow } = storeState
  return context.queryClient.fetchQuery(
    walletTermsQueryOptions({
      isPayCardAccount: essentialFlow,
    })
  )
}
